// REST calls as the signed-in user. A failed call throws the server's own message.

import { useAuth } from "../state/auth.js";

export async function api<T>(path: string, init?: { method: string; body?: unknown }): Promise<T> {
  const token = useAuth.getState().token;
  const res = await fetch(path, {
    method: init?.method ?? "GET",
    headers: {
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(init?.body !== undefined ? { "content-type": "application/json" } : {}),
    },
    ...(init?.body !== undefined ? { body: JSON.stringify(init.body) } : {}),
  });
  const body = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new Error(body.error ?? "Something went wrong.");
  return body;
}
